import { DiagnosticReport } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  REPORT_SEARCH_DEFAULTS,
  reportSearchConfig,
  type ReportSearchParams,
} from './reportSearchConfig';

export type { ReportSearchParams };
export { REPORT_SEARCH_DEFAULTS };

export function useReportSearch(medplum: MedplumClient, patientId?: string) {
  return useGenericResourceSearch<ReportSearchParams, DiagnosticReport>(
    medplum,
    reportSearchConfig,
    patientId
  );
}

